<template>
  <a-row class="missing-parameter-page" justify="center" align="middle">
    <a-col :span="24">
      <a-card class="card" bordered>
        <template #title>
          <h2 class="card-title">参数缺失</h2>
        </template>
        <div class="content">
          <a-icon
            class="warning-icon"
            type="warning"
            style="font-size: 50px; color: #e6a23c"
          />
          <h3>缓存中的参数过期！</h3>
          <p>
            请求中缺少必填的参数：缺失的参数为<strong>{{
              missingParam
            }}</strong>
          </p>
          <p>
            解决方案：
            如果你是pc端企微，切换聊天会话后在重新打开侧边栏，刷新重试。如果你是手机端企微侧边栏，请重新进入聊天会话页面。
          </p>
        </div>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import store from "@/store";
export default {
  name: "MissingParameterPage",
  data() {
    return {
      missingParam: "",
    };
  },
  methods: {},
  mounted() {
    console.log(store);
    if (!store.getters.corpId) {
      this.missingParam += "corpId ";
    }
    if (!store.getters.agentId) {
      this.missingParam += "agentId ";
    }
    //   localStorage.getItem("MISSING_PARAMETER_CURRENTPATH") || "参数为空";
  },
};
</script>

<style scoped>
.missing-parameter-page {
  min-height: 100vh;
  background-color: #f4f7fc;
}

.card {
  padding: 30px;
}

.card-title {
  text-align: center;
  color: #333;
  font-size: 24px;
  font-weight: bold;
}

.content {
  text-align: center;
}

.warning-icon {
  color: #e6a23c;
}

h3 {
  margin: 20px 0;
  color: #333;
  font-size: 20px;
}

p {
  color: #999;
  font-size: 16px;
}

strong {
  color: #f56c6c;
}

.el-button {
  margin-top: 20px;
}
</style>
